import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

import { SidebarSection, SidebarSubsection } from "./types";

@Component({
  selector: "ta-sidebar-section",
  templateUrl: "./section.template.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionComponent {

  @Input()
  section: SidebarSection;

  @Input()
  currentSubsectionId: string;

  @Output()
  currentSubsectionChange: EventEmitter<string> = new EventEmitter();

  handleSubsectionClick(value: string): void {
    if (value !== this.currentSubsectionId) {
      this.currentSubsectionChange.emit(value);
    }
  }

  @Input()
  depth: number = 0;

  sortSubsections(subsections: SidebarSubsection[]): SidebarSubsection[] {
    return subsections.slice().sort((subsectionA, subsectionB) => subsectionA.ord - subsectionB.ord);
  }
}
